module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension imoveis-toolbar",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo titulo-imoveis"
  }, [_vm._v("Imóveis")]), _vm._v(" "), _c('div', {
    staticClass: "opcoes_lista_mapa opcoes_lista_mapa_mobile"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisLista'
      }
    }
  }, [_c('v-btn', {
    staticClass: "opcao-view-btn",
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("list")]), _vm._v(" Lista\n        ")], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ImoveisMapa'
      }
    }
  }, [_c('v-btn', {
    staticClass: "opcao-view-btn",
    attrs: {
      "flat": "",
      "ripple": false
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("room")]), _vm._v(" Mapa\n        ")], 1)], 1)], 1)]), _vm._v(" "), _c('gmap-map', {
    ref: "map",
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 142px)"
    },
    attrs: {
      "center": _vm.center,
      "zoom": _vm.currentZoom,
      "options": {
        clickableIcons: false,
        streetViewControl: false,
        fullscreenControl: false,
        minZoom: 7,
        maxZoom: 17,
        zoomControlOptions: {
          position: _vm.zoomPosition
        }
      }
    },
    on: {
      "bounds_changed": function($event) {
        _vm.updateBounds($event)
      },
      "zoom_changed": function($event) {
        _vm.updateZoom($event)
      },
      "idle": _vm.idleLoadImoveis
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": {
        lat: _vm.coords.latitude,
        lng: _vm.coords.longitude
      },
      "clickable": false,
      "icon": _vm.currentLocationIcon
    }
  }), _vm._v(" "), _vm._l((_vm.imoveis), function(item, index) {
    return (item.endereco !== undefined) ? _c('gmap-marker', {
      key: item.id,
      ref: 'marker' + item.id,
      refInFor: true,
      attrs: {
        "position": {
          lat: item.endereco.data.latitude,
          lng: item.endereco.data.longitude
        },
        "icon": _vm.getIcon(item),
        "clickable": true
      },
      on: {
        "click": function($event) {
          _vm.clickMarker(item)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.infoWindowOpened) ? _c('mapa-info-window', {
    key: _vm.infoWindowImovel.id,
    attrs: {
      "marker": _vm.infoWindowMarker,
      "imovel": _vm.infoWindowImovel,
      "is-open": _vm.infoWindowOpened
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('v-layout', {
    staticClass: "mapa_botoes",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "scale-transition"
    }
  }, [(_vm.legenda) ? _c('v-flex', {
    staticClass: "mb-2 legenda-card-col",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "subheading secondary--text uppercase text-xs-center mb-4"
  }, [_c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right legenda_cores"
  }, [_c('div', [_vm._v("Sem status "), _c('span', {
    staticClass: "legenda_cor",
    style: ({
      'background-color': _vm.colors.undefined
    })
  })]), _vm._v(" "), _vm._l((_vm.colors), function(item, index) {
    return (index !== 'undefined') ? _c('div', {
      key: index,
      staticClass: "my-3"
    }, [_vm._v(_vm._s(index) + " "), _c('span', {
      staticClass: "legenda_cor",
      style: ({
        'background-color': item
      })
    })]) : _vm._e()
  })], 2)])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "legenda-btn-col",
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-btn', {
    staticClass: "white secondary--text legenda-btn",
    attrs: {
      "large": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.legenda = !_vm.legenda
      }
    }
  }, [_vm._v("Legenda")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-257abbde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/ImoveisMapa.vue
// module id = 998
// module chunks = 1